import { GetBusinessInfoResponse } from "@1games-ru/region-shared/dist/backend/requests/business";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import BusinessMpProvider from "@/core/data-provider/data-mp/business/business-mp-provider";
import useAppSelector from "@/core/helpers/useAppSelector";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";
import { offerResolverSelector } from "@/domains/offer/slice";
import toast from "@/domains/toasts/helpers/toast";

export default function useOfferResolverBusiness(isShow: boolean) {
  const { t, i18n } = useTranslation("offer");
  const [business, setBusiness] = useState<GetBusinessInfoResponse | null>(null);
  const [pending, setPending] = useState<boolean>(false);
  const offerResolver = useAppSelector(offerResolverSelector);

  const load = useCallback(async () => {
    if (!offerResolver) {
      return;
    }

    try {
      setBusiness(null);
      setPending(true);
      const response = await BusinessMpProvider.getInfo(offerResolver.targetId);

      if (response instanceof RpcMpProviderFailedResponse) {
        if (i18n.exists(`offer:offer.errors.${response.error.message}`)) {
          console.error(response.error.message);
          toast.error(t(`offer.errors.${response.error.message}`));
        } else {
          console.error(response.error.message);
          toast.error(t("offer.errors.loadError"));
        }
        return;
      }

      setBusiness(response.data);
    } catch (error) {
      console.error(error);
      toast.error(t("offer.errors.loadError"));
    } finally {
      setPending(false);
    }
  }, [offerResolver, i18n, t]);

  useEffect(() => {
    if (isShow) {
      load();
    }
  }, [isShow, load]);

  return {
    business,
    pending,
  };
}
